module.exports = __webpack_public_path__ + "static/laptop-dc0996b130f17da258912825dd6a3a3d.png";